export enum SearchActions {
  READ = 'read',
  NEXT = 'next',
}